import React from 'react';
import { Alert } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

const PublicIntentInfo = (
  <Alert status="warning">
    <strong>Important:</strong> please read our{' '}
    <Link
      href={`${BASE_DOC_URL_VB}/publish/integration-publishing-requirements`}
      target="_blank"
    >
      publishing requirements for public integrations
    </Link>{' '}
    before building your integration. Read more about{' '}
    <Link
      href={`${BASE_DOC_URL_VB}/quickstart/private-vs-public-integrations`}
      target="_blank"
    >
      public vs private integrations
    </Link>
    .
  </Alert>
);

export default PublicIntentInfo;
